import { render } from "./addTemplate.vue?vue&type=template&id=c9911034"
import script from "./addTemplate.vue?vue&type=script&lang=js"
export * from "./addTemplate.vue?vue&type=script&lang=js"

import "@/assets/css/new.scss?vue&type=style&index=0&lang=scss"
import "./addTemplate.vue?vue&type=style&index=1&id=c9911034&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__